import React from 'react';
import { Routes, Route } from 'react-router-dom';
import TicketsTab from '../Inbound/TicketsTab';
import TicketDetail from '../Inbound/TicketDetail';

export default function TicketsApp() {
  return (
    <Routes>
      <Route index element={<TicketsTab />} />
      <Route path=":ticketId" element={<TicketDetail />} />
    </Routes>
  );
}
